// ============================================
// UTILS/TIEMPO.JS — Antiguedad en lenguaje humano
// ============================================
// "hace 2 min", "hace 3 dias", "hace 2 meses". Se usa para decir de cuando es el
// dato que se esta viendo (ej. la ultima actualizacion de un producto Syscom).

const MINUTO = 60;
const HORA = 60 * MINUTO;
const DIA = 24 * HORA;
const MES = 30 * DIA;
const ANO = 365 * DIA;

// Devuelve "hace X" o null si la fecha no sirve. Nunca lanza: si el dato viene
// corrupto se prefiere no mostrar nada antes que pintar "Invalid Date".
export function hace(fecha) {
  if (!fecha) return null;
  const t = new Date(fecha).getTime();
  if (!Number.isFinite(t)) return null;
  const seg = Math.floor((Date.now() - t) / 1000);
  // Reloj adelantado del cliente o fecha futura: se trata como "recien".
  if (seg < 45) return 'hace unos segundos';
  if (seg < HORA) {
    const n = Math.round(seg / MINUTO);
    return `hace ${n} min`;
  }
  if (seg < DIA) {
    const n = Math.floor(seg / HORA);
    return `hace ${n} hora${n === 1 ? '' : 's'}`;
  }
  if (seg < MES) {
    const n = Math.floor(seg / DIA);
    return n === 1 ? 'ayer' : `hace ${n} dias`;
  }
  if (seg < ANO) {
    const n = Math.floor(seg / MES);
    return `hace ${n} ${n === 1 ? 'mes' : 'meses'}`;
  }
  const n = Math.floor(seg / ANO);
  return `hace ${n} año${n === 1 ? '' : 's'}`;
}

// true si el dato ya tiene tantos dias o mas (para avisar que esta viejo).
export function masViejoQue(fecha, dias) {
  if (!fecha) return false;
  const t = new Date(fecha).getTime();
  if (!Number.isFinite(t)) return false;
  return (Date.now() - t) / 1000 >= dias * DIA;
}
